import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ObjetosContratosService } from "../../../../shared/services/objetos_contratos.service";
import { VehiclesService } from "../../../../shared/services/vehicles.service";
import {
  PlanillaService,
  Planilla,
} from "../../../../shared/services/planillas.service";
import { Utils } from "../../../../shared/utils/Utils";
import jsPDF from "jspdf";
import * as QRCode from 'qrcode';
import { gpcGoogleService } from "../../../../shared/services/gpcGoogle.service";
import { AdministracionService } from "../../../../shared/services/administracion.services";
import { Administracion } from "../../../../shared/model/administracion.model";
import { environment } from "../../../../../environments/environment";
const Swal = require("sweetalert2");

@Component({
  selector: "app-consultar",
  templateUrl: "./consultar.component.html",
  styleUrls: ["./consultar.component.scss"],
})
export class ConsultarComponent implements OnInit {

  @ViewChild("inputObjeto") inputObjeto!: ElementRef;
  @ViewChild("inputFinicial") inputFinicial!: ElementRef;
  @ViewChild("inputFinal") inputFinal!: ElementRef;


  objetos: any[] = [];
  vehiculos: any[] = [];
  hoy: string = ""; 
  formNuevo!: FormGroup;
  public searchText: string = ""; // Texto de búsqueda
  formPlanilla!: FormGroup;
  resultadosPlanillas: Planilla[] = [];
  pageSize1: number = 5;
  page1: number = 1;
  totalItems!: number;
  filteredTableItems!: Planilla[];
  planillas: any[] = [];
  mostrarTabla: boolean = false;
  mensajeBusqueda!: string;
  minFechaFinal: string = "";
  administraciones: Administracion[] = []; 
   altura: number = 0;
  ancho: number = 0;
  posicionX: number = 0;
  posicionY: number = 0;
   mostrandoToast = false;
  constructor(
    private objetosContratosService: ObjetosContratosService,
    private vehiclesService: VehiclesService,
    private planillaService: PlanillaService,
    private fb: FormBuilder,
    private gpcGoogle: gpcGoogleService,
     private administracionesServices: AdministracionService,
    
  ) {}

  ngOnInit(): void {
    this.inicializarFormularios();
    this.cargarVehiculos();
    this.cargarObjetos();
    this.cargarDataAdmin();
  }

  private inicializarFormularios(): void {
    this.formNuevo = this.fb.group({
      placa: [null],
    });

    this.formPlanilla = this.fb.group({
      objeto: [null],
      placa: [null],
      finicial: [null],
      ffinal: [null],
    });
  }

  private cargarVehiculos(): void {
    this.vehiclesService.getPlacasUnicas().subscribe({
      next: (data) => (this.vehiculos = data),
      error: (error) => console.error("❌ Error al obtener vehículos:", error),
    });
  }

  private cargarObjetos(): void {
    this.objetosContratosService.getObjetos().subscribe({
      next: (data) => (this.objetos = data),
      error: (error) => console.error("❌ Error al obtener objetos:", error),
    });
  }

consultarFuec(): void {
  const objeto = this.formPlanilla.value.objeto;
  const placa = this.formPlanilla.value.placa?.trim();
  const finicial = this.formPlanilla.value.finicial?.trim();
  const ffinal = this.formPlanilla.value.ffinal?.trim();

  console.log('📥 Valores del formulario:', {
    objeto,
    placa,
    finicial,
    ffinal
  });

  const camposRequeridos = [
   
    {
      campo: "finicial",
      mensaje: "una fecha inicial",
      ref: this.inputFinicial,
    },
    {
      campo: "ffinal",
      mensaje: "una fecha final",
      ref: this.inputFinal,
    },
  ];

  for (const campo of camposRequeridos) {
    if (!this.formPlanilla.get(campo.campo)?.value) {
      this.mostrarAlerta2(
        "Campo requerido",
        `Por favor, selecciona ${campo.mensaje}`,
        "info"
      );
      campo.ref?.nativeElement.focus();
      return;
    }
  }

  if (!objeto && !placa && !finicial && !ffinal) {
    this.resultadosPlanillas = [];
    this.filteredTableItems = [];
    this.mensajeBusqueda = "Debes proporcionar al menos un filtro para buscar.";
    this.mostrarTabla = false;
    return;
  }

 // console.log('📤 Enviando al servicio:', { objeto, placa, finicial, ffinal });

  this.planillaService
    .buscarPlanillasPorFiltros(objeto, placa, finicial, ffinal)
    .subscribe({
      next: (resp) => {
        console.log('📦 Respuesta recibida:', resp);

        this.resultadosPlanillas = resp.planillas;
        this.filteredTableItems = resp.planillas;
        this.mensajeBusqueda = resp.mensaje || "";
        this.mostrarTabla = true;
      },
      error: (err) => {
        console.error('❌ Error al buscar planillas:', err);

        this.resultadosPlanillas = [];
        this.filteredTableItems = [];
        this.mensajeBusqueda = "Ocurrió un error al buscar planillas.";
        this.mostrarTabla = true;
      },
    });
}


  private mostrarAlerta2(titulo: string, mensaje: string, icono: any) {
    Swal.fire({
      title: titulo,
      text: mensaje,
      icon: icono,
      confirmButtonColor: "#3085d6",
    });
  }

  //recibe el id de la tabla vista, nombre con el que descargará el archivo, titulo del documento
  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  filterData() {
    const search = this.searchText?.toLowerCase() || "";

    if (!search) {
      this.filteredTableItems = [...this.resultadosPlanillas]; // Usar resultados reales
      return;
    }

    this.filteredTableItems = this.resultadosPlanillas.filter(
      (item) =>
        item.contratoNumero?.toLowerCase().includes(search) ||
        item.interno?.toLowerCase().includes(search) ||
        item.placa?.toLowerCase().includes(search) ||
        item.responsable?.toLowerCase().includes(search) || // asegúrate de que este campo exista
        item.objeto?.toLowerCase().includes(search) ||
        item.empresa?.toLowerCase().includes(search) // asegúrate también de que exista
    );

    this.page1 = 1;
  }

  // En tu componente TypeScript (por ejemplo, planillas.component.ts)
  get algunFiltroActivo(): boolean {
    const form = this.formPlanilla.value;
    return !!(form.objeto || form.placa || form.finicial || form.ffinal);
  }

  actualizarMinFechaFinal(): void {
    const fechaInicialStr = this.formPlanilla.get("finicial")?.value;

    if (fechaInicialStr) {
      const finicial = new Date(fechaInicialStr);
      const ffinal = new Date(finicial);
      ffinal.setDate(ffinal.getDate() + 1); // suma 1 día

      // Formato local: yyyy-MM-dd
      this.minFechaFinal = [
        ffinal.getFullYear(),
        String(ffinal.getMonth() + 1).padStart(2, '0'),
        String(ffinal.getDate()).padStart(2, '0')
      ].join('-');

      const fechaFinalControl = this.formPlanilla.get("ffinal");
      if (
        fechaFinalControl?.value &&
        fechaFinalControl.value < this.minFechaFinal
      ) {
        fechaFinalControl.setValue("");
      }
    }
  }

  formatoFecha(fecha: Date): string {
    return fecha.toISOString().split("T")[0];
  }
  // ✅ Resta días exactos a una fecha
  restarDias(fecha: Date, dias: number): Date {
    const nuevaFecha = new Date(fecha);
    nuevaFecha.setDate(nuevaFecha.getDate() - dias);
    return nuevaFecha;
  }
  // ✅ Selecciona el rango dinámicamente según el botón presionado
  seleccionarRango(
    rango: "dia" | "semana" | "mes" | "trimestre" | "semestre" | "anio"
  ): void {
    const hoy = new Date(); // 📅 Fecha actual
    let diasARestar = 0;

    switch (rango) {
      case "dia":
        diasARestar = 1;
        break;
      case "semana":
        diasARestar = 7;
        break;
      case "mes":
        diasARestar = 30;
        break;
      case "trimestre":
        diasARestar = 90;
        break;
      case "semestre":
        diasARestar = 180;
        break;
      case "anio":
        diasARestar = 365;
        break;
    }

    const finicial = this.restarDias(hoy, diasARestar);
    const fechaInicioStr = this.formatoFecha(finicial);
    const fechaFinStr = this.formatoFecha(hoy);

    this.minFechaFinal = fechaInicioStr;

    this.formPlanilla.patchValue({
      finicial: fechaInicioStr,
      ffinal: fechaFinStr,
    });
  }

  padNumero(numero: number): string {
  return numero.toString().padStart(4, '0');
}

 async addHeaderImages(
    doc: jsPDF,
    gpcGoogle: any,
    imageMap: Record<string, { path: string; x: number; y: number; w: number; h: number }>,
    fallbackPath: string
  ) {
    // Obtener URL firmada de forma segura
    const getSignedUrlSafe = async (path: string) => {
      try {
        const res = await gpcGoogle.getSignedUrl(path).toPromise();
        return res?.url || null;
      } catch {
        return null;
      }
    };

    // Obtener imagen en base64, con fallback
    const getBase64WithFallback = async (url: string | null, fallbackPath: string) => {
      if (url) {
        try {
          return await gpcGoogle.getImageBase64(url);
        } catch {
          // fallback
        }
      }
      return await gpcGoogle.getImageBase64(fallbackPath);
    };

    // Comprimir base64 usando canvas
    const compressBase64Image = async (base64: string, quality = 0.1): Promise<string> => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          if (!ctx) return reject("No canvas context");
          ctx.drawImage(img, 0, 0);
          const compressed = canvas.toDataURL("image/png", quality); // quality 0–1
          resolve(compressed);
        };
        img.onerror = reject;
        img.src = base64;
      });
    };

    // 1. Obtener las claves y rutas
    const imageEntries = Object.entries(imageMap);

    // 2. Obtener URLs firmadas
    const signedUrls = await Promise.all(
      imageEntries.map(([_, img]) => getSignedUrlSafe(img.path))
    );

    // 3. Obtener y comprimir Base64
    const base64Images = await Promise.all(
      signedUrls.map(async (url, index) => {
        const base64 = await getBase64WithFallback(url, fallbackPath);
        return base64 ? await compressBase64Image(base64, 0.6) : null; // puedes ajustar el 0.6
      })
    );

    // 4. Agregar imágenes al PDF
    base64Images.forEach((base64, idx) => {
      if (base64) {
        const { x, y, w, h } = imageEntries[idx][1];
        doc.addImage(base64, "JPEG", x, y, w, h, undefined, "FAST");
      }
    });
  }

async imprimirFuec(idFuec:any){
  this.planillaService.getPlanillaById(idFuec).subscribe({
  next: (response) => {   
    console.log("FUEC:", response); 
   
   if(response.codigo==0){
    this.generarFuec(response.Planilla);
   }
    
  },
  error: (error) => {
    
  }
});
}



async generarFuec(planilla: any) {
  const doc = new jsPDF();
  //console.log("🧾 Generando FUEC con:", planilla);
   await this.addHeaderImages(doc, this.gpcGoogle, {
      supertransporte: { path: "ministerio/supertransporte.png", x: 105, y: 20, w: 50, h: 16 },
      minsupertransporte: { path: "ministerio/mintransporte.png", x: 55, y: 20, w: 50, h: 16 },
      potencia: { path: "ministerio/potencia.png", x: 10, y: 21, w: 40, h: 16 },
       logo: { path: `${this.administraciones[0].nit}/logos/logo.png`, x: this.posicionX, y: this.posicionY, w: this.ancho, h: this.altura },
   
    }, "../../../../../assets/images/hoja_vida/sinfoto.png");
  // Puedes acceder a todo el contenido
 
  const clase = planilla.clase;
   // === MARCA DE AGUA (de fondo) ===
const pageWidth = doc.internal.pageSize.getWidth();
const pageHeight = doc.internal.pageSize.getHeight();
// Opcional: Guardar estilos actuales
doc.saveGraphicsState();
doc.setFont('helvetica', 'normal');
doc.setFontSize(100);
doc.setTextColor(232, 232, 232); // Gris claro
doc.text('ORIGINAL', pageWidth / 2, pageHeight / 2, {
  align: 'center',
  angle: 0
});

doc.restoreGraphicsState();
  // Encabezado
  doc.setFontSize(12);
  doc.text('FICHA TÉCNICA DEL FORMATO ÚNICO DEL EXTRACTO DEL CONTRATO - FUEC', 105, 15, { align: 'center' });


  
  // Datos del contrato 


  doc.setFontSize(11);
  let y = 45;
  
  doc.setFont("helvetica","bold");
  doc.text('FORMATO ÚNICO DE EXTRACTO DEL CONTRATO DEL SERVICIO PÚBLICO DE', 105, y,{ align: 'center' });
   y += 5;
  doc.text('TRANSPORTE TERRESTRE AUTOMOTOR ESPECIAL', 105, y,{ align: 'center' });
  y += 5;
  const contratoFormateado1 = String(planilla.contrato).padStart(4, '0')
  const idfuecFormateado = String(planilla.idfuec).padStart(4, '0')
  doc.text('No '+ planilla.nfuec +contratoFormateado1+idfuecFormateado, 105, y,{ align: 'center' });
  


  doc.setFontSize(8);
  doc.setFont('helvetica', 'bold');

    y += 10;
  // Datos de la empresa
  doc.text('RAZÓN SOCIAL DE LA EMPRESA DE TRANSPORTE ESPECIAL:', 10, y);
  doc.text(planilla.infoEmpresa.empresa, 98, y);
   y += 5;
  doc.text('NIT:', 10, y);
  doc.text(planilla.nite, 60, y);


  // Datos del contrato
   y += 5;
  doc.setFont('helvetica', 'bold');
  doc.text('CONTRATO No.:', 10, y);
  doc.setFont('helvetica', 'normal');
  const contratoFormateado = planilla.contrato.toString().padStart(4, '0');
  doc.text(contratoFormateado, 60, y);
  

  y += 5;
  doc.setFont('helvetica', 'bold');
  doc.text('CONTRATANTE:', 10, y);
  doc.setFont('helvetica', 'normal');
  
  doc.text(planilla.nitc, 60, y);

  y += 5;
  doc.setFont('helvetica', 'bold');
  doc.text('NIT/CC:', 10, y);
  doc.setFont('helvetica', 'normal');
  doc.text(planilla.empresa, 60, y);

  // Objeto
   y += 5;
  doc.setFont('helvetica', 'bold');
  doc.text('OBJETO DEL CONTRATO:', 10,y);
  doc.setFont('helvetica', 'normal');
  doc.text(planilla.descripcionObjeto.descripcion, 60,y);
  
    if (planilla.complemento) {
    y += 3;
    doc.setFontSize(7); // Reducir tamaño de fuente para disponibilidad
    const maxWidth = 140; // Ancho máximo para el texto
    const textLines = doc.splitTextToSize(planilla.complemento, maxWidth);
    doc.text(textLines, 60, y);
    // Ajustar Y según la cantidad de líneas del complemento
    y += (textLines.length - 1) * 4;
   }
  // ORIGEN DESTION VIAJE
   y += 5;
    doc.setFontSize(8); // Reducir tamaño de fuente para disponibilidad
  doc.setFont('helvetica', 'bold');
  doc.text('ORIGEN - DESTINO:', 10,y);
  doc.setFont('helvetica', 'normal');
  
  if (planilla.disponibilidad) {
    doc.setFontSize(7); // Reducir tamaño de fuente para disponibilidad
    const maxWidth = 140; // Ancho máximo para el texto
    const textLines = doc.splitTextToSize('DISPONIBILIDAD TOTAL:' + planilla.disponibilidad + " " + planilla.descripcionViaje.descripcion, maxWidth);
    doc.text(textLines, 60, y);
    // Ajustar Y según la cantidad de líneas (cada línea ocupa ~4 unidades con fuente más pequeña)
    y += (textLines.length - 1) * 4;
    doc.setFontSize(8); // Restaurar tamaño de fuente
  } else {

  doc.setFontSize(8);
    const maxWidth = 150; // Ancho máximo para el texto
    const textLines = doc.splitTextToSize(planilla.origen + ' - ' + planilla.destino + " " + planilla.descripcionViaje.descripcion, maxWidth);
    doc.text(textLines, 60, y);
    // Ajustar Y según la cantidad de líneas
    y += (textLines.length - 1) * 4;
  
  }

  // ORIGEN DESTION VIAJE
   y += 5;
   doc.setFontSize(8);
   if(planilla.conv && planilla.conv!=""){
    doc.setFont('helvetica', 'bold');
    doc.text('CONVENIO DE COLABORACIÓN:', 10,y);
    doc.setFont('helvetica', 'normal');
    doc.text( planilla.vehiculo.nombreEmpresa.nombre, 60,y);
   }else{
     doc.setFont('helvetica', 'bold');
    doc.text('CONVENIO DE COLABORACIÓN:', 10,y);
    doc.setFont('helvetica', 'normal');
    doc.text( "-", 60,y);
   }
  
  
     y += 10;
   doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('VIGENCIA DEL CONTRATO', 105, y,{ align: 'center' });

  // Estilos de fondo y bordes
doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(12);
 y += 2;
// Coordenadas y anchos de columnas
const x1 = 10;
const w1 = 92;

const x2 = x1 + w1;   // 105
const w2 = 30;
const w3 = 30;
const w4 = 30;

// Dibujar celdas
doc.rect(x1, y, w1, 10, 'S');             // FECHA INICIAL
doc.rect(x2, y, w2, 10, 'S');             // DÍA
doc.rect(x2 + w2, y, w3, 10, 'S');        // MES
doc.rect(x2 + w2 + w3, y, w4, 10, 'S');   // AÑO



const fecha = new Date(planilla.finicial);
const dia = String(fecha.getUTCDate()).padStart(2, '0');
const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
const anio = String(fecha.getUTCFullYear());


// Escribir texto centrado
doc.setFont('helvetica', 'normal');
doc.text("FECHA INICIAL", x1 + 2, y + 7); // alineado a la izquierda (2px de margen)
doc.setFont('helvetica', 'bold');
doc.text("DÍA", x2 + w2 / 2, y + 4.5, { align: 'center' });

doc.setFont('helvetica', 'normal');
doc.text(dia, x2 + w2 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.text("MES", x2 + w2 + w3 / 2, y + 4.5, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.text(mes, x2 + w2 + w3 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.text("AÑO", x2 + w2 + w3 + w4 / 2, y + 4.5, { align: 'center' })
doc.setFont('helvetica', 'normal');
doc.text(anio, x2 + w2 + w3 + w4 / 2, y + 9, { align: 'center' });

  y += 2;
     

   // Estilos de fondo y bordes
doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(12);
 y += 8;



// Dibujar celdas
doc.rect(x1, y, w1, 10, 'S');             // FECHA INICIAL
doc.rect(x2, y, w2, 10, 'S');             // DÍA
doc.rect(x2 + w2, y, w3, 10, 'S');        // MES
doc.rect(x2 + w2 + w3, y, w4, 10, 'S');   // AÑO

const fecha2 = new Date(planilla.ffinal);
const dia2 = String(fecha2.getUTCDate()).padStart(2, '0');
const mes2 = String(fecha2.getUTCMonth() + 1).padStart(2, '0');
const anio2 = String(fecha2.getUTCFullYear());

// Escribir texto centrado
doc.text("FECHA VENCIMIENTO", x1 + 2, y + 7); // alineado a la izquierda (2px de margen)
doc.text("DÍA", x2 + w2 / 2, y + 4.5, { align: 'center' });
doc.text(dia2, x2 + w2 / 2, y + 9, { align: 'center' });

doc.text("MES", x2 + w2 + w3 / 2, y + 4.5, { align: 'center' });
doc.text(mes2, x2 + w2 + w3 / 2, y + 9, { align: 'center' });
doc.text("AÑO", x2 + w2 + w3 + w4 / 2, y + 4.5, { align: 'center' })
doc.text(anio2, x2 + w2 + w3 + w4 / 2, y + 9, { align: 'center' });

 
  y += 20;
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('CARACTERÍSTICA DEL VEHÍCULO', 105, y,{ align: 'center' });
  y += 2;

 
     

   // Estilos de fondo y bordes
doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(12);



const x11 = 10;

// Anchos de columnas
const w11 = 45; // PLACA
const w22 = 46; // MODELO
const w33 = 45; // MARCA
const w44 = 46; // CLASE

// Dibujar celdas
doc.rect(x11, y, w11, 10, 'S');                   // PLACA
doc.rect(x11 + w11, y, w22, 10, 'S');              // MODELO
doc.rect(x11 + w11 + w22, y, w33, 10, 'S');         // MARCA
doc.rect(x11 + w11 + w22 + w33, y, w44, 10, 'S');    // CLASE

// Escribir texto centrado en cada celda (horizontal y vertical)
const yText = y + 6; // Centrado verticalmente (ajustable)

doc.text("PLACA", x11 + w11 / 2, yText, { align: 'center' });
doc.text("MODELO", x11 + w11 + w22 / 2, yText, { align: 'center' });
doc.text("MARCA", x11 + w11 + w22 + w33 / 2, yText, { align: 'center' });
doc.text("CLASE", x11 + w11 + w22 + w33 + w44 / 2, yText, { align: 'center' });
 y += 10;
doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(10);

// Dibujar celdas
doc.rect(x11, y, w11, 10, 'S');                   // PLACA
doc.rect(x11 + w11, y, w22, 10, 'S');              // MODELO
doc.rect(x11 + w11 + w22, y, w33, 10, 'S');         // MARCA
doc.rect(x11 + w11 + w22 + w33, y, w44, 10, 'S');    // CLASE
 doc.setFont('helvetica', 'normal');
 doc.text(planilla.placa, x11 + w11 / 2, y + 6, { align: 'center' }); //PLACA

const modeloStr = planilla.modelo ? String(planilla.modelo) : '';
doc.text(modeloStr, x11 + w11 + w22 / 2, y + 6, { align: 'center' }); //MODELO

doc.text(planilla.marca, x11 + w11 + w22 + w33 / 2, y + 6, { align: 'center' }); //MARCA
doc.text(clase, x11 + w11 + w22 + w33 + w44 / 2, y + 6, { align: 'center' }); //CLASE

//interno
 y += 10; // Moverse a la siguiente fila

const x111 = 10;
const w111 = 45;
const h = 10;

doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(10);

doc.setFont('helvetica', 'bold');
// Celda 1: INTERNO
doc.rect(x111, y, w111 + 46, h, 'S');
doc.text("NÚMERO INTERNO", x111 + (w111 + 46) / 2, y + 6, { align: 'center' });

doc.setFillColor(255, 255, 255); // fondo blanco
doc.setTextColor(0, 0, 0);       // texto negro
doc.setDrawColor(0);            // bordes negros

// Celda 1: INTERNO
doc.rect(x111+91, y, w111 + 46, h, 'S');
doc.text("TARJETA DE OPERACIÓN", x111 +91+ (w111 + 46) / 2, y + 6, { align: 'center' });


doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(10);
// ↓↓↓ NUEVA FILA DE VALORES DEBAJO ↓↓↓
y += h;

// Valor debajo de NÚMERO INTERNO
doc.rect(x111, y, w111 + 46, h, 'S');
doc.setFont('helvetica', 'normal');
const internoStr = planilla.interno ? String(planilla.interno) : '';
doc.text(internoStr, x111 + (w111 + 46) / 2, y + 6, { align: 'center' });


doc.setFillColor(255, 255, 255); // fondo blanco
doc.setDrawColor(0);            // bordes negros
doc.setFontSize(10);
doc.setFont('helvetica', 'normal');
// Valor debajo de TARJETA DE OPERACIÓN
doc.rect(x111 + 91, y, w111 + 46, h, 'S');
const tarjetaStr = planilla.operaciones ? String(planilla.operaciones) : '';
doc.text(tarjetaStr, x111 + 91 + (w111 + 46) / 2, y + 6, { align: 'center' });


 y += 10; // Moverse a la siguiente fila

const h2 = 14;
const x112 = 10;
const w112 = 32;

doc.rect(x112, y, w112, h2, 'S');
doc.rect(x112, y, w112+59, h2, 'S');
doc.rect(x112, y, w112+59+29, h2, 'S');
doc.rect(x112, y, w112+59+55, h2, 'S');
doc.rect(x112, y, w112+59+91, h2, 'S');
// Agregar texto dividido en dos líneas
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("DATOS DEL", x112 + w112 / 2, y + 4.5, { align: 'center' });
doc.text("CONDUCTOR No. 1", x112 + w112 / 2, y + 9, { align: 'center' });
doc.text("NOMBRES Y APELLIDOS", x112 + 122 / 2, y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');

if (!planilla.conductor || planilla.conductor.trim() === '') {
  planilla.conductor = "-";
}

if (!planilla.cedula || planilla.cedula.trim() === '') {
  planilla.cedula = "-";
}

if (!planilla.licencia || planilla.licencia.trim() === '') {
  planilla.licencia = "-";
}

doc.text(planilla.conductor, x112 + 122 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.text("NÚMERO CEDULA", x112 +105 , y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(10);
doc.text(planilla.cedula, x112 + 105, y + 9, { align: 'center' });

const xText = x112 + 105 + 28; // posición X centrada para la columna
const yStart = y + 4;          // posición Y inicial ajustada para que el texto quede centrado verticalmente

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("NÚMERO LICENCIA", xText, yStart, { align: 'center' });
doc.text("CONDUCCIÓN", xText, yStart + 4, { align: 'center' });

doc.setFont('helvetica', 'normal');
doc.setFontSize(10);
doc.text(planilla.licencia, xText, yStart + 8, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("VIGENCIA", xText+30, yStart, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(10);

if(planilla.vigencia){
const fechaOriginal = planilla.vigencia;
const fecha1 = new Date(fechaOriginal);

const fechaFormateada = fecha1.toLocaleDateString('es-CO', {
  timeZone: 'UTC',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
});
doc.text(fechaFormateada, xText+30, yStart + 8, { align: 'center' });
}else{
  doc.text("-", xText+30, yStart + 8, { align: 'center' });
}






y += 14; // Moverse a la siguiente fila
doc.rect(x112, y, w112, h2, 'S');
doc.rect(x112, y, w112+59, h2, 'S');
doc.rect(x112, y, w112+59+29, h2, 'S');
doc.rect(x112, y, w112+59+55, h2, 'S');
doc.rect(x112, y, w112+59+91, h2, 'S');
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("DATOS DEL", x112 + w112 / 2, y + 4.5, { align: 'center' });
doc.text("CONDUCTOR No. 2", x112 + w112 / 2, y + 9, { align: 'center' });
doc.text("NOMBRES Y APELLIDOS", x112 + 122 / 2, y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');

if (!planilla.conductor1 || planilla.conductor1.trim() === '') {
  planilla.conductor1 = "-";
}

if (!planilla.cedula1 || planilla.cedula1.trim() === '') {
  planilla.cedula1 = "-";
}

if (!planilla.licencia1 || planilla.licencia1.trim() === '') {
  planilla.licencia1 = "-";
}



doc.text(planilla.conductor1, x112 + 122 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');

doc.text("NÚMERO CEDULA", x112 +105 , y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(10);
doc.text(planilla.cedula1, x112 + 105, y + 9, { align: 'center' });

const xText1 = x112 + 105 + 28; // posición X centrada para la columna
const yStart1 = y + 4;          // posición Y inicial ajustada para que el texto quede centrado verticalmente

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("NÚMERO LICENCIA", xText1, yStart1, { align: 'center' });
doc.text("CONDUCCIÓN", xText1, yStart1 + 4, { align: 'center' });

doc.setFont('helvetica', 'normal');
doc.setFontSize(8);
doc.text(planilla.licencia1, xText1, yStart1 + 8, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("VIGENCIA", xText1+30, yStart1, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(10);

if(planilla.vigencia1){
const fechaOriginal22 = planilla.vigencia1;
const fecha221 = new Date(fechaOriginal22);

const fechaFormateada22 = fecha221.toLocaleDateString('es-CO', {
  timeZone: 'UTC',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
});
doc.text(fechaFormateada22, xText1+30, yStart1 + 8, { align: 'center' });
}else{
  doc.text("-", xText1+30, yStart1 + 8, { align: 'center' });
}






y += 14; // Moverse a la siguiente fila
doc.rect(x112, y, w112, h2, 'S');
doc.rect(x112, y, w112+59, h2, 'S');
doc.rect(x112, y, w112+59+29, h2, 'S');
doc.rect(x112, y, w112+59+55, h2, 'S');
doc.rect(x112, y, w112+59+91, h2, 'S');
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("DATOS DEL", x112 + w112 / 2, y + 4.5, { align: 'center' });
doc.text("CONDUCTOR No. 3", x112 + w112 / 2, y + 9, { align: 'center' });
doc.text("NOMBRES Y APELLIDOS", x112 + 122 / 2, y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
if (!planilla.conductor2 || planilla.conductor2.trim() === '') {
  planilla.conductor2 = "-";
}

if (!planilla.cedula2 || planilla.cedula2.trim() === '') {
  planilla.cedula2 = "-";
}

if (!planilla.licencia2 || planilla.licencia2.trim() === '') {
  planilla.licencia2 = "-";
}



doc.text(planilla.conductor2, x112 + 122 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.text("NÚMERO CEDULA", x112 +105 , y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(8);
doc.setFontSize(10);
doc.text(planilla.cedula2, x112 + 105, y + 9, { align: 'center' });

const xText11 = x112 + 105 + 28; // posición X centrada para la columna
const yStart11 = y + 4;          // posición Y inicial ajustada para que el texto quede centrado verticalmente

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("NÚMERO LICENCIA", xText11, yStart11, { align: 'center' });
doc.text("CONDUCCIÓN", xText11, yStart11 + 4, { align: 'center' });

doc.setFont('helvetica', 'normal');
doc.setFontSize(10);
doc.text(planilla.licencia2, xText11, yStart11 + 8, { align: 'center' });

if(planilla.vigencia2){
const fechaOriginal2 = planilla.vigencia2;
const fecha22 = new Date(fechaOriginal2);

const fechaFormateada2 = fecha22.toLocaleDateString('es-CO', {
  timeZone: 'UTC',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
});

//console.log(fechaFormateada2); // "07/03/2026"
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("VIGENCIA", xText11+30, yStart11, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.setFontSize(10);
doc.text(fechaFormateada2, xText11+30, yStart11 + 8, { align: 'center' });
}else{
  doc.text("-", xText11+30, yStart11 + 8, { align: 'center' });
}



y += 14; // Moverse a la siguiente fila
doc.rect(x112, y, w112, h2, 'S');
doc.rect(x112, y, w112+59, h2, 'S');
doc.rect(x112, y, w112+59+29, h2, 'S');
doc.rect(x112, y, w112+59+55, h2, 'S');
doc.rect(x112, y, w112+59+91, h2, 'S');
doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("DATOS DEL", x112 + w112 / 2, y + 4.5, { align: 'center' });
doc.text("RESPONSABLE", x112 + w112 / 2, y + 9, { align: 'center' });
doc.text("NOMBRES Y APELLIDOS", x112 + 122 / 2, y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.text(planilla.responsable, x112 + 122 / 2, y + 9, { align: 'center' });

doc.setFont('helvetica', 'bold');
doc.text("NÚMERO CEDULA", x112 +105 , y + 4.0, { align: 'center' });
doc.setFont('helvetica', 'normal');
doc.text(planilla.idresponsable, x112 + 105, y + 9, { align: 'center' });

const xText111 = x112 + 105 + 28; // posición X centrada para la columna
const yStart111 = y + 4;          // posición Y inicial ajustada para que el texto quede centrado verticalmente

doc.setFont('helvetica', 'bold');
doc.setFontSize(7);
doc.text("TELÉFONO", xText111, yStart111, { align: 'center' });


doc.setFont('helvetica', 'normal');
doc.setFontSize(8);
const telefonorStr = planilla.telefonor ? String(planilla.telefonor) : '';
doc.text(telefonorStr, xText111, yStart111 + 5, { align: 'center' });

const textDireccion = planilla.direccionr || '';
const maxWidth = 40; // ajusta al ancho máximo que quieras
const textLines = doc.splitTextToSize(textDireccion, maxWidth);

doc.setFont('helvetica', 'bold');
doc.text("DIRECCIÓN", xText111 + 30, yStart111, { align: 'center' });

doc.setFont('helvetica', 'normal');
doc.text(textLines, xText111 + 30, yStart111 + 3, { align: 'center' });

y += 14; // Moverse a la siguiente fila
doc.rect(x112, y, w112+59, h2+20, 'S');
doc.rect(x112+91, y, w112+59, h2+20, 'S');
doc.setFont('helvetica', 'normal');
y += 5;
doc.setFontSize(10);
doc.text(planilla.infoEmpresa.direccion, 12,y);

y += 5; // Moverse a la siguiente fila
const telefonoStr =planilla.infoEmpresa.telefono ? String(planilla.infoEmpresa.telefono) : '';
doc.text(telefonoStr, 12,y);
y += 5; // Moverse a la siguiente fila
doc.text(planilla.infoEmpresa.email, 12,y);
y += 5; // Moverse a la siguiente fila
doc.text(planilla.infoEmpresa.web, 12,y);

if (this.administraciones.length > 0) {
  const firmaPath = this.administraciones[0].nit + "/logos/firma.png";
  try {
    const firmaUrl = await this.gpcGoogle.getSignedUrl(firmaPath).toPromise();
    if (firmaUrl?.url) {
      // Intentar obtener la imagen, solo agregar si existe
      try {
        const firmaBase64 = await this.gpcGoogle.getImageBase64(firmaUrl.url);
        if (firmaBase64) {
          doc.addImage(firmaBase64, "PNG", 115, y-10, 60, 15);
        }
      } catch (e) {
        // No agregar imagen si no existe
      }
    }
  } catch (e) {
    // No agregar imagen si no existe
  }
}
  doc.setFontSize(10);
  doc.text("FIRMA GERENTE EMPRESA", 125, y + 10);
  
  // Registro de fecha y hora en posición fija vertical con formato dd/mm/aa
  doc.setFontSize(8);
  const fechaRegistro = new Date(planilla.registro);
  const diaReg = String(fechaRegistro.getUTCDate()).padStart(2, '0');
  const mesReg = String(fechaRegistro.getUTCMonth() + 1).padStart(2, '0');
  const anioReg = String(fechaRegistro.getUTCFullYear()).slice(-2);
  const textoRegistro = `${diaReg}/${mesReg}/${anioReg} ${planilla.hora}`;
  doc.text(textoRegistro, 195, 270, { angle: 90 });
  
  // Generar QR y posicionarlo de forma absolutamente fija
  const qrBase64 = await QRCode.toDataURL(environment.apiUrl + "/api/validar-fuec/"+ this.administraciones[0].consumidas+"/"+planilla.idfuec);
  
  // Posición fija en la parte inferior izquierda (sin depender de variables dinámicas)
  const qrX = 75;
  const qrY = 252; // Posición fija en el eje Y
  const qrSize = 20;
  
  doc.addImage(qrBase64, 'PNG', qrX, qrY, qrSize, qrSize);
   this.addFooter(doc, planilla.idfuec);

  // Abrir el PDF en nueva pestaña
  const blobUrl = doc.output('bloburl');
  window.open(blobUrl, '_blank');
}
addFooter(doc: jsPDF,  id: string | number) {
  const pageWidth = doc.internal.pageSize.width;

  const now = new Date();
  const fecha = now.toLocaleDateString("es-CO", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const hora = now.toLocaleTimeString("es-CO", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const fechaHora = `${fecha} ${hora}`;
  const idFormatted = String(id).padStart(4, '0'); // ejemplo: 0042

  doc.setFont("helvetica", "italic");
  doc.setFontSize(8);
  doc.setTextColor(100);

  // Posiciones fijas del footer
  const footerY1 = 291; // Posición fija para fecha/ID
  const footerY2 = 291; // Posición fija para texto central

  // 🕓 Izquierda: Fecha y hora
  doc.text(fechaHora, 10, footerY1);

  // 🏢 Centro: Texto con enlace
  doc.textWithLink(
    "Generado desde Admin SEAF – INDESOFT - ORIGINAL",
    pageWidth / 2,
    footerY2,
    {
      url: "https://indesoftsas.com",
      align: "center",
    }
  );

  // 📄 Derecha: ID + número de página
  doc.text(`ID: ${idFormatted} `, pageWidth - 10, footerY1, {
    align: "right",
  });
  this.mostrandoToast = false;
}


    private cargarDataAdmin(): void {
    this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {

        this.administraciones = data;
        this.altura = data[0].dimensionLogo.h;      // "8"
        this.ancho = data[0].dimensionLogo.w;       // "40"
        this.posicionX = data[0].dimensionLogo.fx;   // 10
        this.posicionY = data[0].dimensionLogo.fy;  
      
      
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
  }


}